var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmergencyHvac({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 111,
    height: 95,
    viewBox: "0 0 111 95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M96.824 72H100c6.075 0 11 4.925 11 11v12h-6V84a6 6 0 00-6-6h-2.176v-6z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M97.324 72.5v5H99a6.5 6.5 0 016.5 6.5v10.5h5V83c0-5.799-4.701-10.5-10.5-10.5h-2.676z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M7 86h85v9H7z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M7.5 86.5h84v8h-84z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M5 0h89a5 5 0 015 5v77a5 5 0 01-5 5H5a5 5 0 01-5-5V5a5 5 0 015-5z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M5 .5A4.5 4.5 0 00.5 5v77A4.5 4.5 0 005 86.5h89a4.5 4.5 0 004.5-4.5V5A4.5 4.5 0 0094 .5H5zM38 33l7 7m0-7l-7 7m16-7l7 7m0-7l-7 7"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M66 53.5c-4.477-.567-10.87-1-16.262-1-6.087 0-11.866.29-16.738 1M9.5 9.5h15m-15 8h15m-15-4h15m-15 8h15m-15 4h15m-15 8h15m-15-4h15m-15 8h15m-15 4h15m-15 8h15m-15-4h15m-15 8h15m-15 4h15m-15 8h15m-15-4h15m-15 8h15m-15 4h15m-15 4h15m7-68h15m-15 8h15m-15-4h15m-15 8h15m-15 44h15m-15 4h15m-15 4h15m-15 4h15m7-68h15m-15 8h15m-15-4h15m-15 8h15m-15 44h15m-15 4h15m-15 4h15m-15 4h15m7-68h15m-15 8h15m-15-4h15m-15 8h15m-15 4h15m-15 8h15m-15-4h15m-15 8h15m-15 4h15m-15 8h15m-15-4h15m-15 8h15m-15 4h15m-15 8h15m-15-4h15m-15 8h15m-15 4h15m-15 4h15"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergencyHvac);
export default __webpack_public_path__ + "static/media/EmergencyHvac.149229997ebb74ed74465eb21824c81e.svg";
export { ForwardRef as ReactComponent };